import React, { useEffect, useState, useContext } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Spinner,
  Modal,
  Form,
  Alert,
  Badge,
  Pagination,
} from "react-bootstrap";
import Header from "./Header"; // Assuming Header component exists
import { getCachedData, setCachedData } from "../utils/apiCache";
import { useNavigate } from "react-router-dom"; // If using React Router; adjust if needed
import axios from "axios"; // Assuming axios is installed for API calls
import moment from "moment"; // For date handling
import DatePicker from "react-datepicker"; // Install react-datepicker for date picker
import "react-datepicker/dist/react-datepicker.css"; // Import styles
import { Dropdown } from "react-bootstrap"; // Using Bootstrap Dropdown for document type
import { ProductContext } from "../context/AppContext";
// Mock context or props for student data; adjust based on your app structure
// Assuming a context or props provide student data similar to Native
const StudentDocumentRequest = () => {
  const navigate = useNavigate(); // For navigation if needed
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const { GetstudentData, Automationdata } = useContext(ProductContext);
  const studentId = GetstudentData?.id;
  console.log(GetstudentData, "GetstudentData1500");

  console.log(studentId, "studentId 1500");
  const [showApplyModal, setShowApplyModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [formData, setFormData] = useState({
    documentType: "",
    reason_for_leaving: "",
    leaving_date: "",
    session_id: "", // Fetch from student profile
  });
  const [selectedPaymentOption, setSelectedPaymentOption] = useState(null);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [getStudentData, setGetStudentData] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [showDocPreviewModal, setShowDocPreviewModal] = useState(false);
  const [previewHtml, setPreviewHtml] = useState("");
  const [previewLoading, setPreviewLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const [selectedFilter, setSelectedFilter] = useState("");

  // Mock student data; replace with actual context or props
  const StudentProfileData = {
    id: 28, // Mock student ID
    class_section_id: 1,
    session: 2025, // Mock session
    father_full_name: "John Doe",
    mother_full_name: "Jane Doe",
    guardian_name: "",
    father_mobile_no: "1234567890",
    mother_mobile_no: "0987654321",
    guardian_mobile_no: "",
    father_email: "john@example.com",
    mother_email: "jane@example.com",
    guardian_email: "",
  };

  const StudentId = GetstudentData?.id;
  const StudentClassSectionId = GetstudentData?.class_section_id;
  const StudentSessionId = GetstudentData?.session;

  const StudentContactName =
    GetstudentData?.father_full_name ||
    GetstudentData?.mother_full_name ||
    GetstudentData?.guardian_name;
  const StudentContactNumber =
    GetstudentData?.father_mobile_no ||
    GetstudentData?.mother_mobile_no ||
    GetstudentData?.guardian_mobile_no;
  const StudentContactEmail =
    GetstudentData?.father_email ||
    GetstudentData?.mother_email ||
    GetstudentData?.guardian_email;

  const safeValue = (val) => (val && val !== "null" ? val : null);

  const allName = [
    safeValue(GetstudentData?.father_full_name),
    safeValue(GetstudentData?.mother_full_name),
    safeValue(GetstudentData?.guardian_name),
  ].filter(Boolean);
  const StudentFamilyName = allName.join(", ");

  const allMobile = [
    safeValue(GetstudentData?.father_mobile_no),
    safeValue(GetstudentData?.mother_mobile_no),
    safeValue(GetstudentData?.guardian_mobile_no),
  ].filter(Boolean);
  const StudentFamilyMobileNo = allMobile.join(", ");

  const allEmails = [
    safeValue(GetstudentData?.father_email),
    safeValue(GetstudentData?.mother_email),
    safeValue(GetstudentData?.guardian_email),
  ].filter(Boolean);
  const StudentFamilyEmail = allEmails.join(", ");

  const authToken = localStorage.getItem("token");

  useEffect(() => {
    if (studentId) {
      fetchStudentDocuments(selectedFilter);
    }
  }, [studentId, selectedFilter]);

  useEffect(() => {
    fetchFeeData();
  }, []);

  const fetchStudentDocuments = async (docType = selectedFilter) => {
    if (!studentId) return;
    const cacheKey = `doc_reqs_${studentId}_${docType}`;
    const cached = getCachedData(cacheKey);
    if (cached) {
      setData(cached);
      setLoading(false);
      
    }
    try {
      if (!cached) setLoading(true);
      let url = `https://api.mirai.healthcare/api/head/diary/document-requests?requester_id=${studentId}&requester_type=STUDENT`;
      if (docType) {
        url += `&document_type=${docType}`;
      }
      const response = await axios.get(url, {
        headers: {
          "x-auth": authToken,
        },
      });
      if (response.data.success && Array.isArray(response.data.requests)) {
        const sortedRequests = response.data.requests.sort((a, b) => b.id - a.id);
        setData(sortedRequests);
        setCachedData(cacheKey, sortedRequests);
        setCurrentPage(1);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Failed to fetch documents.");
    } finally {
      setLoading(false);
    }
  };

  const fetchFeeData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `https://api.mirai.healthcare/api/fee-service/fee-categories/id-card`,
        {
          headers: {
            "x-auth": authToken,
            "Content-Type": "application/json",
          },
        }
      );
      setGetStudentData(response.data);
    } catch (err) {
      console.error("API error:", err);
      setError("Failed to fetch fee data.");
      if (err.response?.status === 401) {
        // Handle logout/navigation to login
        localStorage.removeItem("token");
        navigate("/login");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleDropdownChange = (value, label) => {
    handleChange("documentType", value);
  };

  const handlePaymentSelect = (option) => {
    setSelectedPaymentOption(option);
  };

  const handleDateChange = (date) => {
    setSelectedStartDate(date);
    handleChange("leaving_date", moment(date).format("YYYY-MM-DD"));
  };

  const handleSubmit = async () => {
    if (!formData.documentType) {
      setError("Please select a document type.");
      return;
    }
    setSubmitLoading(true);
    try {
      const payload = {
        documentType: formData.documentType,
        session_id: StudentSessionId,
        data: {
          studentId: studentId,
          reason_for_leaving: formData.reason_for_leaving,
          leaving_date: formData.leaving_date,
        },
      };

      const response = await axios.post(
        "https://api.mirai.healthcare/api/head/diary/document-requests",
        payload,
        {
          headers: {
            "x-auth": authToken,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        setSuccessMessage("Document request submitted successfully.");
        setError(null);
        if (formData.documentType === "identity_card") {
          handlePayNow(response.data.request?.id);
        }
        setShowApplyModal(false);
        fetchStudentDocuments(); // Refresh list
        // Navigate if needed
        // navigate("/student-document-request");
      } else {
        setError(response.data.message || "Failed to submit request.");
        setSuccessMessage(null);
      }
    } catch (error) {
      console.error("Error:", error);
      setError(
        error.response?.data?.message || "Failed to submit document request."
      );
      setSuccessMessage(null);
    } finally {
      setSubmitLoading(false);
    }
  };

  const handlePayNow = async (requesterId) => {
    const payAmount = getStudentData?.fee_config?.amount;
    const paymentDetails = {
      amount: payAmount,
      productinfo: "identity_card",
      firstname: StudentContactName,
      email: StudentContactEmail,
      phone: StudentContactNumber,
      reqDocId: requesterId,
      paymentMethod: Automationdata?.data?.[0]?.PaymentMethod,
    };
    const query = new URLSearchParams({
      ...paymentDetails,
      authToken: authToken || "",
    }).toString();

    const url = `${window.location.origin}/pay-u-payment?${query}`;
    window.open(url, "_blank"); // Open in new tab for web
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowImageModal(true);
  };

  const handleViewDocument = async (id) => {
    setPreviewLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `https://api.mirai.healthcare/api/head/diary/document-requests/${id}/document`,
        {
          headers: {
            "x-auth": authToken,
            Accept: "text/html",
          },
          responseType: "text",
        }
      );
      setPreviewHtml(response.data);
      setShowDocPreviewModal(true);
    } catch (err) {
      console.error("Error fetching document HTML:", err);
      setError("Failed to load document preview.");
    } finally {
      setPreviewLoading(false);
    }
  };

  const handlePrintDocument = () => {
    const win = window.open("", "", "width=900,height=650");
    win.document.write(`
      <html>
        <head>
          <title>Print Document</title>
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
          <style>
            body {
              margin: 0;
              padding: 20px;
              background: #fff;
            }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          ${previewHtml}
        </body>
      </html>
    `);
    win.document.close();
  };

  // Pagination calculations
  const totalPages = Math.ceil(data.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const maxPageNumbersToShow = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    let endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

    if (endPage - startPage < maxPageNumbersToShow - 1) {
      startPage = Math.max(1, endPage - maxPageNumbersToShow + 1);
    }

    return (
      <div className="d-flex flex-column align-items-center mt-4 w-100">
        <Pagination className="shadow-sm mb-1">
          <Pagination.First
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          />
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />

          {startPage > 1 && (
            <>
              <Pagination.Item onClick={() => handlePageChange(1)}>1</Pagination.Item>
              {startPage > 2 && <Pagination.Ellipsis disabled />}
            </>
          )}

          {Array.from({ length: endPage - startPage + 1 }, (_, i) => {
            const pageNum = startPage + i;
            return (
              <Pagination.Item
                key={pageNum}
                active={pageNum === currentPage}
                onClick={() => handlePageChange(pageNum)}
              >
                {pageNum}
              </Pagination.Item>
            );
          })}

          {endPage < totalPages && (
            <>
              {endPage < totalPages - 1 && <Pagination.Ellipsis disabled />}
              <Pagination.Item onClick={() => handlePageChange(totalPages)}>
                {totalPages}
              </Pagination.Item>
            </>
          )}

          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
          <Pagination.Last
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
        <span className="text-muted small">
          Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, data.length)} of {data.length} requests
        </span>
      </div>
    );
  };

  if (loading) {
    return (
      <Container className="mt-5 text-center">
        <Spinner animation="border" />
      </Container>
    );
  }

  return (
    <div className="page-wrapper">
      <Header />
      <Container fluid className="mt-4 py-2" style={{ padding: "0px 25px" }}>
        {/* <div className="text-center my-4">
          <h2 className="fw-bold">Student Document Requests</h2>
        </div>
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <h4 className="fw-bold mb-0">Your Requests</h4>
          <Button variant="primary" onClick={() => setShowApplyModal(true)} className="btn-sm btn-md">
            Apply New Request
          </Button>
        </div> */}

        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
          <h2
            className="page-title fw-bold mb-0"
            style={{ letterSpacing: "0.5px" }}
          >
            Student Document Requests
          </h2>

          <div className="d-flex align-items-center gap-3 flex-wrap">
            <Form.Group className="mb-0 d-flex align-items-center gap-2">
              <Form.Label className="fw-bold mb-0 text-nowrap text-muted small">
                Document Type:
              </Form.Label>
              <Form.Select
                value={selectedFilter}
                onChange={(e) => setSelectedFilter(e.target.value)}
                style={{ width: "220px" }}
                className="shadow-sm"
              >
                <option value="">All Documents</option>
                <option value="identity_card">ID Card</option>
                <option value="tc">Transfer Certificate</option>
                <option value="bonafide">Bonafide Certificate</option>
              </Form.Select>
            </Form.Group>

            <Button
              variant="primary"
              onClick={() => setShowApplyModal(true)}
              className="shadow-sm"
            >
              <i className="bi bi-plus-lg me-2"></i>Apply New Request
            </Button>
          </div>
        </div>

        {data.length === 0 ? (
          <div className="text-center py-5 shadow-sm rounded border bg-white">
            <p className="text-muted mb-0">
              No document requests found. Apply for one above.
            </p>
          </div>
        ) : (
          <>
            <div className="table-responsive shadow-sm rounded border bg-white mb-3">
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light text-nowrap">
                  <tr>
                    <th scope="col" style={{ width: "80px" }}>ID</th>
                    <th scope="col">Document Type</th>
                    <th scope="col">Requested On</th>
                    <th scope="col">Payment Status</th>
                    <th scope="col">Student Reason</th>
                    <th scope="col">Status</th>
                    <th scope="col">Remarks</th>
                    <th scope="col" className="text-end" style={{ width: "200px" }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((doc, index) => {
                    const documentTypeMap = {
                      identity_card: "ID Card",
                      tc: "Transfer Certificate",
                      bonafide: "Bonafide Certificate",
                    };
                    const displayName =
                      documentTypeMap[doc.document_type] ||
                      doc.document_type ||
                      "Document";

                    const getStatusBadgeBg = (status) => {
                      switch (status?.toLowerCase()) {
                        case "approved":
                          return "success";
                        case "pending":
                          return "warning";
                        case "rejected":
                        case "cancelled":
                          return "danger";
                        default:
                          return "secondary";
                      }
                    };

                    const requestedDate = doc.created_at
                      ? moment(doc.created_at).format("DD-MM-YYYY hh:mm A")
                      : "N/A";

                    return (
                      <tr key={index}>
                        <td className="fw-bold text-muted">#{doc.id}</td>
                        <td className="fw-semibold text-dark">{displayName}</td>
                        <td className="text-muted small">{requestedDate}</td>
                        <td>
                          <Badge
                            bg={doc.payment_status === "paid" ? "success" : "warning"}
                            className="px-2 py-1"
                          >
                            {doc.payment_status ? doc.payment_status.toUpperCase() : "UNPAID"}
                          </Badge>
                        </td>
                        <td className="text-secondary small text-wrap" style={{ maxWidth: "250px" }}>
                          {doc.data?.reason_for_leaving || "-"}
                        </td>
                        <td>
                          <Badge bg={getStatusBadgeBg(doc.status)} className="px-2 py-1">
                            {doc.status ? doc.status.toUpperCase() : "PENDING"}
                          </Badge>
                        </td>
                        <td className="text-secondary small text-wrap" style={{ maxWidth: "250px" }}>
                          {doc.admin_reason || "-"}
                        </td>
                        <td className="text-end">
                          <div className="d-flex justify-content-end gap-2 flex-nowrap">
                            {doc.status === "approved" &&
                              (doc.document_type !== "tc" || doc.publish === true) && (
                                <Button
                                  variant="primary"
                                  size="sm"
                                  className="d-flex align-items-center gap-1 shadow-sm text-nowrap"
                                  onClick={() => handleViewDocument(doc.id)}
                                  disabled={previewLoading}
                                >
                                  {previewLoading ? (
                                    <Spinner animation="border" size="sm" />
                                  ) : (
                                    <i className="bi bi-eye"></i>
                                  )}
                                  View
                                </Button>
                              )}
                            {doc.document_type === "identity_card" &&
                              doc.payment_status !== "paid" && (
                                <Button
                                  variant="outline-primary"
                                  size="sm"
                                  className="d-flex align-items-center gap-1 shadow-sm text-nowrap"
                                  onClick={() => handlePayNow(doc.id)}
                                >
                                  <i className="bi bi-credit-card"></i> Pay Now
                                </Button>
                              )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            {renderPagination()}
          </>
        )}

        {/* Apply Modal - Redesigned to match Native */}
        <Modal
          show={showApplyModal}
          onHide={() => setShowApplyModal(false)}
          centered
          size="md"
          className="modal-dialog-centered text-white"
        >
          <Modal.Header
            closeButton
            closeVariant="white"
            className="bg-primary text-white"
          >
            <Modal.Title className="text-white">Apply for Document</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4">
            {error && (
              <Alert variant="danger" className="mb-3">
                {error}
              </Alert>
            )}
            {successMessage && (
              <Alert variant="success" className="mb-3">
                {successMessage}
              </Alert>
            )}
            <Form>
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Document Type</Form.Label>
                <Dropdown onSelect={handleDropdownChange}>
                  <Dropdown.Toggle
                    variant="outline-secondary"
                    id="dropdown-basic"
                    className="w-100 text-start"
                  >
                    {formData.documentType
                      ? formData.documentType
                      : "Select Document Type"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="w-100">
                    <Dropdown.Item eventKey="identity_card">
                      ID Card
                    </Dropdown.Item>
                    <Dropdown.Item eventKey="tc">
                      Transfer Certificate
                    </Dropdown.Item>
                    <Dropdown.Item eventKey="bonafide">
                      Bonafide Certificate
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Form.Group>

              {formData.documentType === "tc" && (
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Leaving Date</Form.Label>
                  <DatePicker
                    selected={selectedStartDate}
                    onChange={handleDateChange}
                    dateFormat="yyyy-MM-dd"
                    className="form-control"
                    minDate={new Date()}
                    placeholderText="Select Leaving Date"
                  />
                </Form.Group>
              )}

              {formData.documentType === "identity_card" && getStudentData && (
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">Payment Option</Form.Label>
                  <div className="d-flex gap-2 flex-wrap">
                    <Button
                      variant={
                        selectedPaymentOption === "school"
                          ? "primary"
                          : "outline-primary"
                      }
                      size="sm"
                      className="flex-fill text-nowrap"
                      onClick={() => handlePaymentSelect("school")}
                    >
                      <i className="bi bi-building me-1"></i>
                      Pay at School (₹{getStudentData.fee_config?.amount})
                    </Button>
                    <Button
                      variant={
                        selectedPaymentOption === "now"
                          ? "primary"
                          : "outline-primary"
                      }
                      size="sm"
                      className="flex-fill text-nowrap"
                      onClick={() => handlePaymentSelect("now")}
                    >
                      <i className="bi bi-credit-card me-1"></i>
                      Pay Now (₹{getStudentData.fee_config?.amount})
                    </Button>
                  </div>
                </Form.Group>
              )}

              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Reason</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  placeholder="Enter reason for request..."
                  value={formData.reason_for_leaving}
                  onChange={(e) =>
                    handleChange("reason_for_leaving", e.target.value)
                  }
                  className="form-control"
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer className="px-4 pb-4">
            <Button
              variant="secondary"
              className="me-2"
              onClick={() => setShowApplyModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleSubmit}
              disabled={submitLoading || !formData.documentType}
            >
              {submitLoading ? (
                <Spinner animation="border" size="sm" className="me-2" />
              ) : null}
              Submit Request
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Image Viewer Modal */}
        <Modal
          show={showImageModal}
          onHide={() => setShowImageModal(false)}
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Document Viewer</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center p-0">
            {selectedImage && (
              <img
                src={selectedImage}
                alt="Document"
                style={{
                  maxWidth: "100%",
                  maxHeight: "80vh",
                  objectFit: "contain",
                }}
                className="img-fluid"
              />
            )}
          </Modal.Body>
        </Modal>

        {/* Document Preview Modal */}
        <Modal
          show={showDocPreviewModal}
          onHide={() => setShowDocPreviewModal(false)}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Document Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-4" style={{ maxHeight: "70vh", overflowY: "auto" }}>
            <div
              id="document-content"
              dangerouslySetInnerHTML={{ __html: previewHtml }}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowDocPreviewModal(false)}
            >
              Close
            </Button>
            <Button variant="primary" onClick={handlePrintDocument}>
              <i className="bi bi-printer me-2"></i> Print / Save as PDF
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  );
};

export default StudentDocumentRequest;
